import Helper from '../../lib/Helper';

export default {
	_attribute           : 'data-banner',
	_resizeDetectionDelay: 25,
	_banners             : [],
	_timer               : null,
	init() {
		window.removeEventListener('resize', this._onResize);
		this._banners = document.querySelectorAll(`[${this._attribute}]`);
		if (!this._banners.length) {
			return;
		}
		this._process();
		window.addEventListener('resize', this._onResize.bind(this));
	},
	_onResize() {
		clearTimeout(this._timer);
		this._timer = setTimeout(this._process.bind(this), this._resizeDetectionDelay);
	},
	_process() {
		const fullWidth  = Helper.getWindowWidth();
		const innerWidth = Helper.getWindowWidth(true);
		let percentage   = 75;
		if (fullWidth >= 1024) {
			percentage = 37.5;
		} else if (fullWidth >= 768) {
			percentage = 62.5;
		}
		Array.prototype.forEach.call(this._banners, banner => {
			banner.style.maxHeight = `${(innerWidth * percentage) / 100}px`;
		});
	}
};